import { defineComponent as V, useTemplateRef as h, ref as S, computed as N, watch as g, nextTick as F, openBlock as C, createElementBlock as _, createVNode as k, unref as t, toDisplayString as w, createCommentVNode as E } from "vue";
import { RevButtonIcon as y } from "@ds/components/ButtonIcon";
import I from "../../../icons/generated/IconChevronLeft.vue2.js";
import L from "../../../icons/generated/IconChevronRight.vue2.js";
import { useI18n as M } from "@ds/plugin";
import d from "../../../translations/generic.translations.js";
const P = { class: "hidden gap-12 md:flex md:items-center" }, $ = {
  key: 0,
  "aria-atomic": "true",
  "aria-live": "polite",
  class: "sr-only"
}, q = /* @__PURE__ */ V({
  __name: "CardCarouselController",
  props: {
    prevAlternativeText: {},
    nextAlternativeText: {},
    canScrollPrev: { type: Boolean, default: !1 },
    canScrollNext: { type: Boolean, default: !1 },
    firstVisible: { default: void 0 },
    lastVisible: { default: void 0 },
    totalItems: { default: void 0 }
  },
  emits: ["scroll"],
  setup(c, { emit: b }) {
    const o = c, v = b, u = M(), m = h("prevButtonRef"), p = h("nextButtonRef"), n = S(null), R = () => {
      n.value = "prev", v("scroll", "backward");
    }, T = () => {
      n.value = "next", v("scroll", "forward");
    }, x = N(() => o.firstVisible === void 0 || o.lastVisible === void 0 || o.totalItems === void 0 ? "" : u(d.cardCarouselShowingSlides, {
      first: o.firstVisible,
      last: o.lastVisible
    })), B = (e, a, r) => {
      const f = n.value === a, i = r === e, l = e instanceof HTMLElement && e.contains(r);
      return f || e !== void 0 && (i || l);
    };
    return g(
      [() => o.canScrollPrev, () => o.canScrollNext],
      async ([e, a], [r, f]) => {
        await F();
        const { activeElement: i } = document, l = m.value?.$el, s = p.value?.$el;
        r && !e && a && B(l, "prev", i) && s instanceof HTMLButtonElement && (s.focus(), n.value = "next"), f && !a && e && B(s, "next", i) && l instanceof HTMLButtonElement && (l.focus(), n.value = "prev");
      }
    ), (e, a) => (C(), _("div", P, [
      k(t(y), {
        ref_key: "prevButtonRef",
        ref: m,
        "alternative-text": t(u)(t(d).cardCarouselControllerPrevious),
        disabled: !c.canScrollPrev,
        icon: t(I),
        variant: "primary",
        onClick: R
      }, null, 8, ["alternative-text", "disabled", "icon"]),
      x.value ? (C(), _("span", $, w(x.value), 1)) : E("", !0),
      k(t(y), {
        ref_key: "nextButtonRef",
        ref: p,
        "alternative-text": t(u)(t(d).cardCarouselControllerNext),
        disabled: !c.canScrollNext,
        icon: t(L),
        variant: "primary",
        onClick: T
      }, null, 8, ["alternative-text", "disabled", "icon"])
    ]));
  }
});
export {
  q as default
};
